import React, { useState, useEffect } from "react";
import { getTiktok } from "../api/services";
import { Card, Loading, KpiCard } from "../components/common/UI";
import { fmtNum } from "../utils/format";
import styles from "./pages.module.css";

export default function Tiktok() {
  const [period, setPeriod] = useState("all");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getTiktok(period).then((d) => {
      if (!active) return;
      setData(d);
      setLoading(false);
    });
    const reload = () => getTiktok(period).then((d) => setData(d));
    window.addEventListener("ingest-done", reload);
    return () => { active = false; window.removeEventListener("ingest-done", reload); };
  }, [period]);

  if (loading && !data) return <Loading />;

  if (!data || !data.available) {
    return (
      <div className={styles.page}>
        <h1 className={styles.pageTitle}>TikTok</h1>
        <Card>
          <div style={{ color: "var(--text-mute)", padding: 20 }}>
            Данные ещё не собраны. Нажми «Обновить данные» вверху.
          </div>
        </Card>
      </div>
    );
  }

  const months = data.months || [];
  const top = data.top_videos || [];

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>TikTok</h1>
          <div className={styles.pageSub}>Аналитика @minecraftia_school — верх воронки продаж</div>
        </div>
      </div>

      {months.length > 0 && (
        <div className={styles.tabs} style={{ alignSelf: "flex-start", flexWrap: "wrap" }}>
          {months.map((m) => (
            <button
              key={m.key}
              className={`${styles.tab} ${period === m.key ? styles.tabActive : ""}`}
              onClick={() => setPeriod(m.key)}
            >
              {m.label}
            </button>
          ))}
        </div>
      )}

      <div className={styles.kpiGrid}>
        <KpiCard label="Просмотры" value={fmtNum(data.views)} />
        <KpiCard label="Лайки" value={fmtNum(data.likes)} />
        <KpiCard label="Комментарии" value={fmtNum(data.comments)} />
        <KpiCard label="Репосты" value={fmtNum(data.shares)} />
      </div>

      {top.length > 0 && (
        <Card title="Топ видео по просмотрам">
          <div style={{ display: "flex", flexDirection: "column" }}>
            {top.map((v, i) => (
              <div
                key={i}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  gap: 16, padding: "11px 0", borderBottom: i < top.length - 1 ? "1px solid var(--border)" : "none",
                }}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "center", minWidth: 0 }}>
                  <span style={{ color: "var(--text-mute)", fontSize: 13, width: 22, textAlign: "right" }}>{i + 1}</span>
                  <a
                    href={v.url} target="_blank" rel="noreferrer"
                    style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                    title={v.title}
                  >
                    {v.title || "Видео"}
                  </a>
                </div>
                <div style={{ display: "flex", gap: 18, flexShrink: 0, color: "var(--text-dim)", fontSize: 13 }}>
                  <span title="просмотры"><b style={{ color: "var(--text)" }}>{fmtNum(v.views)}</b> просм.</span>
                  <span title="лайки">{fmtNum(v.likes)} лайк.</span>
                  <span title="комментарии">{fmtNum(v.comments)} комм.</span>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
